/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class DefaultPagesShellConstants {
    public static readonly OPTIONS_CODE_QUERY_PARAMETER = 'options'
    public static readonly PAGE_CODE_QUERY_PARAMETER = 'code'
}